import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { FORM_ID } from "../../../../../constants";
import { RootState } from "../../../../../models";
import { post } from "../../../app/Ajax";
import { VALIDATION_FIELD } from "../../../rapidform/formValidation";
import {
    API_URL_REFILL_SET_EMAIL,
    API_URL_REFILL_SET_REFILL_OPTION,
    API_URL_REFILL_SUBMIT_ORDER,
    API_URL_REFILL_VERIFY_PHONE_NUMBER,
} from "../../api";
import {
    PREPAID_REFILL_SET_REFILL_OPTION,
    PREPAID_REFILL_SUBMIT_ORDER,
    PREPAID_REFILL_VERIFY_PHONE_NUMBER,
} from "../actionTypes";
import * as PREPAID_SELECTORS from "../selectors";

export const verifyRefillPhoneNumber = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch, getState) => {
    const state = getState();
    const { values } = PREPAID_SELECTORS.getFormById(state, FORM_ID.REFILL_PREPAID);
    const phoneNumber = values.prepaidPhoneNumber[VALIDATION_FIELD.PRODUCT_USER_PHONE];
    return dispatch({
        type: PREPAID_REFILL_VERIFY_PHONE_NUMBER,
        payload: post<{ status: string }>(
            {
                url: API_URL_REFILL_VERIFY_PHONE_NUMBER,
                data: { phoneNumber },
            },
            dispatch,
        ).then((res) => {
            return res.status;
        }),
    });
};

export const submitRefillOrder = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch) =>
    dispatch({
        type: PREPAID_REFILL_SUBMIT_ORDER,
        payload: post<{ status: string }>(
            {
                url: API_URL_REFILL_SUBMIT_ORDER,
                data: {},
            },
            dispatch,
        ),
    });

export const setCustomerEmail = (): ThunkAction<void, RootState, unknown, AnyAction> => (dispatch, getState) => {
    const state = getState();
    const { values } = PREPAID_SELECTORS.getFormById(state, FORM_ID.REFILL_PREPAID);
    const email = values.prepaidEmail[VALIDATION_FIELD.EMAIL];
    return dispatch({
        type: PREPAID_REFILL_VERIFY_PHONE_NUMBER,
        payload: post<{ status: string }>(
            {
                url: API_URL_REFILL_SET_EMAIL,
                data: { email },
            },
            dispatch,
        ).then((res) => {
            return res.status;
        }),
    });
};

export const setRefillOption =
    (refillOption: string): ThunkAction<void, RootState, unknown, AnyAction> =>
    (dispatch) => {
        return dispatch({
            type: PREPAID_REFILL_SET_REFILL_OPTION,
            payload: post<{ selectedRefillOptionCodes: string[] }>(
                {
                    url: API_URL_REFILL_SET_REFILL_OPTION,
                    data: { refillOption },
                },
                dispatch,
            ).then((res) => {
                return res.selectedRefillOptionCodes;
            }),
        });
    };
